<template>
  <div>
    <h4>Planes</h4>
    <!-- <button @click="test">Jolas</button> -->
    <!-- <button @click="testFunction()">Jolass</button> -->
    <div class="d-flex flex-column d-md-block">
      <!-- DETAILS -->
      <transition
        name="fade"
        enter-active-class="animate__animated animate__fadeInUp"
        leave-active-class="animate__animated animate__fadeOutUp"
        class="animate__delay-2s"
      >
        <card ref="step4" class="card py-2" v-if="showPlanDetail">
          <div class="wizard-plans-create card-body py-0">
            <form>
              <p class="text-muted border-bottom">Descripción</p>
              <div class="row">
                <div class="col d-flex flex-column">
                  <label>Familia</label>
                  <el-select
                    size="small"
                    v-model="updatedFamily"
                    placeholder="Selecciona"
                    class="success"
                    :disabled="disableFoundPlanForm"
                    @change="calculateSubFamilys"
                  >
                    <el-option
                      v-for="(cat, index) in updateFamilysCatalog"
                      :key="index"
                      :label="cat.nombre"
                      :value="cat"
                    ></el-option>
                  </el-select>
                </div>
                <div class="col d-flex flex-column">
                  <label>Sub-Familia</label>
                  <el-select
                    size="small"
                    v-model="updatedSubFamily"
                    placeholder="Selecciona"
                    class="success"
                    :disabled="disableFoundPlanForm"
                  >
                    <el-option
                      v-for="(cat, index) in updateSubFamilysCatalog"
                      :key="index"
                      :label="cat.nombre"
                      :value="cat"
                    ></el-option>
                  </el-select>
                </div>
                <div class="col">
                  <label for="">Turno</label>
                  <div class="d-flex flex-row">
                    <input
                      type="text"
                      label="Turno"
                      class="form-control col-10"
                      disabled
                      size="small"
                      placeholder="No Seleccionado"
                      v-model="foundPlan.turno.descripcionTurno"
                    />
                    <el-tooltip :open-delay="200" placement="top">
                      <template #content>
                        {{
                          disableFoundPlanForm ? "Ver turno" : "Editar turno"
                        }}
                      </template>
                      <i
                        v-if="foundPlan.turno.descripcionTurno"
                        @click="showShiftModal()"
                        class="fa m-auto cursor-pointer"
                        :class="
                          disableFoundPlanForm
                            ? 'fa-search fa-2x text-info'
                            : 'fa-cog fa-2x text-success'
                        "
                        aria-hidden="true"
                      ></i
                    ></el-tooltip>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-5 col-8">
                  <label for="">Nombre</label>
                  <input
                    type="text"
                    label="Nombre"
                    placeholder="Nuevo plan..."
                    class="form-control"
                    size="small"
                    v-model="foundPlan.descripcion"
                    :readonly="disableFoundPlanForm"
                  />
                </div>
                <div class="col-md-3 col my-auto d-flex flex-column">
                  <label class=""> Tipo de plan </label>
                  <el-select
                    size="small"
                    v-model="foundPlan.convenio"
                    placeholder="Selecciona"
                    class="success"
                    :disabled="disableFoundPlanForm"
                  >
                    <el-option
                      v-for="(cat, index) in plansCatalogs.convenio"
                      :key="index"
                      :label="cat.glosa"
                      :value="cat.glosa"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <p class="text-muted border-bottom mt-2">Venta</p>
              <div class="d-flex flex-row flex-wrap row">
                <div class="col-4 col-md-1 my-auto d-flex">
                  <el-tooltip :open-delay="200" placement="top">
                    <template v-if="foundPlan.habilitarVenta" #content>
                      El plan quedará disponible para su venta en recepción o
                      asingación
                    </template>
                    <template v-else #content>
                      El plan NO estará disponible para su venta en recepción o
                      asingación
                    </template>
                    <div class="switch d-flex flex-column text-center">
                      <label class="text-nowrap"> Habilitado </label>
                      <p-switch
                        v-model="foundPlan.habilitarVenta"
                        type="success"
                        class="mx-auto"
                        on-text="SI"
                        off-text="NO"
                        :readonly="disableFoundPlanForm"
                      ></p-switch>
                    </div>
                  </el-tooltip>
                </div>
                <div class="col-4 col-md-2">
                  <label for="valor">Valor</label>
                  <input
                    type="number"
                    id="valor"
                    class="form-control"
                    label="Valor"
                    placeholder="$0..."
                    min="0"
                    @input="validatePositive"
                    v-model="foundPlan.valor"
                    :readonly="disableFoundPlanForm"
                  />
                </div>
                <div class="col-4 col-md-1 my-auto">
                  <div class="switch d-flex flex-column text-center">
                    <label class="text-nowrap"> Multi-Sede </label>
                    <p-switch
                      v-model="foundPlan.multiSede"
                      type="success"
                      class="mx-auto"
                      on-text="SI"
                      off-text="NO"
                      :readonly="disableFoundPlanForm"
                    ></p-switch>
                  </div>
                </div>
                <div class="col-4 col-md-2 my-auto">
                  <!-- <small
                  ><p class="mb-0" style="color: #9a9a9a">Descuento</p></small
                > -->
                  <label for="" class="text-nowrap">Descuento</label>
                  <el-select
                    size="small"
                    v-model="selectedDiscount"
                    placeholder="Selecciona"
                    class="success"
                    :disabled="disableFoundPlanForm"
                  >
                    <el-option
                      v-for="(amount, index) in discounts"
                      :key="index"
                      :value="amount"
                      >{{ amount }}%</el-option
                    >
                  </el-select>
                </div>
                <div class="col-2 col-md my-auto">
                  <div class="switch d-flex flex-column text-center">
                    <!-- <small
                    ><p class="mb-0 mx-auto text-nowrap text-muted">
                      Matricula
                    </p></small
                  > -->
                    <label class="text-nowrap"> Matricula </label>
                    <p-switch
                      v-model="foundPlan.indicadorMatricula"
                      type="success"
                      class="mx-auto"
                      on-text="SI"
                      off-text="NO"
                      :readonly="disableFoundPlanForm"
                    ></p-switch>
                  </div>
                </div>
                <div v-if="foundPlan.indicadorMatricula" class="col-4 col-md">
                  <label for="">Valor Matricula</label>
                  <input
                    type="number"
                    label="Valor Matricula"
                    class="form-control"
                    size="small"
                    id="valorMatricula"
                    @input="validatePositive"
                    placeholder="$0..."
                    min="0"
                    v-model="foundPlan.valorMatricula"
                    :readonly="disableFoundPlanForm"
                  />
                </div>
                <div class="col-md col-4 my-auto">
                  <!-- <small><p class="mb-0" style="color: #9a9a9a">IVA</p></small> -->
                  <label for="" class="">IVA</label>
                  <el-select
                    size="small"
                    v-model="foundPlan.tipoIVA"
                    placeholder="Selecciona"
                    class="success"
                    :disabled="disableFoundPlanForm"
                  >
                    <el-option label="EXENTO" value="EXENTO"></el-option>
                    <el-option label="AFECTO" value="AFECTO"></el-option>
                  </el-select>
                </div>
                <div class="col-md col-3 my-auto">
                  <div class="switch d-flex flex-column text-center">
                    <!-- <small
                    ><p class="mb-0 mx-auto text-nowrap text-muted">
                      Factura
                    </p></small
                  > -->
                    <label for="" class="text-nowrap">Factura</label>
                    <p-switch
                      v-model="foundPlan.indicadorFactura"
                      type="success"
                      class="mx-auto"
                      on-text="SI"
                      off-text="NO"
                      :readonly="disableFoundPlanForm"
                    ></p-switch>
                  </div>
                </div>
                <div class="col-5 my-auto d-flex d-md-none flex-row px-0">
                  <div class="w-50">
                    <label for="duracion">Duración</label>
                    <input
                      type="number"
                      label="Duración"
                      class="form-control"
                      placeholder=""
                      min="1"
                      id="duracion"
                      @input="validatePositive"
                      v-model="foundPlan.duracion"
                      :readonly="disableFoundPlanForm"
                    />
                  </div>
                  <el-select
                    size="small"
                    v-model="foundPlan.unidadDuracionPlan"
                    placeholder="Selecciona"
                    class="success mt-4 mb-0"
                    :disabled="disableFoundPlanForm"
                  >
                    <el-option
                      el-option
                      v-for="(cat, index) in plansCatalogs.unidadDuracionPlan"
                      :key="index"
                      :label="cat.glosa"
                      :value="cat.glosa"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <p class="text-muted border-bottom">Extensión</p>
              <div class="row">
                <div class="col-3 d-none my-auto d-md-flex flex-row px-0">
                  <div class="col-6">
                    <label for="duracion">Duración</label>
                    <input
                      type="number"
                      label="Duración"
                      class="form-control"
                      placeholder=""
                      min="1"
                      id="duracion"
                      @input="validatePositive"
                      v-model="foundPlan.duracion"
                      :readonly="disableFoundPlanForm"
                    />
                  </div>
                  <el-select
                    size="small"
                    v-model="foundPlan.unidadDuracionPlan"
                    placeholder="Selecciona"
                    class="success mt-4 mb-0"
                    :disabled="disableFoundPlanForm"
                  >
                    <el-option
                      el-option
                      v-for="(cat, index) in plansCatalogs.unidadDuracionPlan"
                      :key="index"
                      :label="cat.glosa"
                      :value="cat.glosa"
                    ></el-option>
                  </el-select>
                </div>
                <div class="col-3 col-md-2 my-auto d-flex flex-column">
                  <label for="disasPermitidoCongelar">Días para congelar</label>
                  <input
                    id="diasPermitidoCongelar"
                    @input="validatePositive"
                    v-model="foundPlan.diasPermitidoCongelar"
                    type="number"
                    size="large"
                    label="Días para congelar"
                    class="form-control"
                    min="0"
                    placeholder=""
                    :readonly="disableFoundPlanForm"
                  />
                </div>
                <div class="col-md col-4 my-auto">
                  <div class="switch d-flex flex-column text-center">
                    <label class="mb-2 text-nowrap"> Plan Sesiones </label>
                    <p-switch
                      v-model="foundPlan.indicadorUsoSesiones"
                      type="success"
                      class="mx-auto"
                      on-text="SI"
                      off-text="NO"
                      :readonly="disableFoundPlanForm"
                    ></p-switch>
                  </div>
                </div>
                <div
                  v-if="foundPlan.indicadorUsoSesiones"
                  class="col-5 col-md my-auto"
                >
                  <label for="sesionesLimite">Cant. Sesiones</label>
                  <input
                    type="number"
                    label="Cant Sesiones"
                    class="form-control"
                    size="small"
                    id="sesionesLimite"
                    min="0"
                    @input="validatePositive"
                    placeholder=""
                    v-model="foundPlan.sesionesLimite"
                    :readonly="disableFoundPlanForm"
                  />
                </div>
                <div class="col-md col-4 my-auto">
                  <div class="switch d-flex flex-column text-center">
                    <label class="mb-2 mx-auto text-nowrap">
                      Mes Calendario
                    </label>
                    <p-switch
                      v-model="foundPlan.indicadorMesCalendario"
                      type="success"
                      class="mx-auto"
                      on-text="SI"
                      off-text="NO"
                      :readonly="disableFoundPlanForm"
                    ></p-switch>
                  </div>
                </div>
                <div class="col-md col-4">
                  <label for="diasMesNoCalendario">Días del mes</label>
                  <input
                    type="number"
                    label="Días del mes"
                    v-model="foundPlan.diasMesNoCalendario"
                    class="form-control"
                    id="diasMesNoCalendario"
                    @input="validatePositive"
                    min="0"
                    placeholder=""
                    :readonly="disableFoundPlanForm"
                  />
                </div>
                <!-- Switches mobile -->
                <div class="col-3 my-auto pl-0 mr-2 d-md-none">
                  <div class="switch d-flex flex-column text-center">
                    <!-- <small
                    ><p class="mb-2 text-nowrap text-muted">
                      Plan Temporal
                    </p></small
                  > -->
                    <label for="" class="text-nowrap">Plan Temporal</label>
                    <p-switch
                      v-model="foundPlan.indicadorVigenciaTemporal"
                      type="success"
                      class="mx-auto"
                      on-text="SI"
                      off-text="NO"
                      :readonly="disableFoundPlanForm"
                    ></p-switch>
                  </div>
                </div>
                <div
                  v-if="foundPlan.indicadorVigenciaTemporal"
                  class="col-6 my-auto d-flex d-md-none flex-column"
                >
                  <label for="datePickerfechaAsignacion"
                    >Inicio de Vigencia</label
                  >
                  <el-date-picker
                    id="datePickerfechaAsignacion"
                    type="date"
                    size="small"
                    format="dd-MM-yyyy"
                    class="w-auto"
                    value-format="dd-MM-yyyy"
                    v-model="foundPlan.fechaInicioVigencia"
                    :readonly="disableFoundPlanForm"
                  >
                  </el-date-picker>
                </div>
                <div
                  v-if="foundPlan.indicadorVigenciaTemporal"
                  class="col-6 my-auto d-flex flex-column d-md-none"
                >
                  <label for="datePickerfechaAsignacion">Fin de Vigencia</label>
                  <el-date-picker
                    id="datePickerfechaAsignacion"
                    type="date"
                    format="dd-MM-yyyy"
                    class="w-auto"
                    size="small"
                    value-format="dd-MM-yyyy"
                    v-model="foundPlan.fechaTerminoVigencia"
                    :readonly="disableFoundPlanForm"
                  >
                  </el-date-picker>
                </div>
                <div
                  class="my-auto my-0 p-0 d-md-none"
                  :class="{
                    'col-3': foundPlan.indicadorPermiteRenovar,
                    'col-3': !foundPlan.indicadorPermiteRenovar,
                  }"
                >
                  <div class="switch d-flex flex-column text-center">
                    <!-- <small
                    ><p class="mb-2 text-center text-nowrap text-muted">
                      ¿Permite Renovar?
                    </p></small
                  > -->
                    <label for="" class="text-nowrap">¿Permite Renovar?</label>
                    <p-switch
                      v-model="foundPlan.indicadorPermiteRenovar"
                      type="success"
                      class="mx-auto"
                      on-text="SI"
                      off-text="NO"
                      :readonly="disableFoundPlanForm"
                    ></p-switch>
                  </div>
                </div>
                <div
                  v-if="foundPlan.indicadorPermiteRenovar"
                  class="col-6 my-auto d-flex flex-row d-md-none"
                >
                  <div
                    class="my-auto"
                    v-if="
                      foundPlan.unidadExpiracionRenovacion !== 'INDEFINIDA (I)'
                    "
                  >
                    <label for="expiracionRenovacion">Expiración</label>
                    <input
                      type="number"
                      label="Expiración"
                      id="expiracionRenovacion"
                      v-model="foundPlan.expiracionRenovacion"
                      class="form-control"
                      placeholder=""
                      @input="validatePositive"
                      min="1"
                      :readonly="disableFoundPlanForm"
                    />
                  </div>
                  <el-select
                    size="small"
                    v-model="foundPlan.unidadExpiracionRenovacion"
                    placeholder="Selecciona"
                    class="success mt-4 mb-0"
                    :disabled="disableFoundPlanForm"
                  >
                    <el-option
                      el-option
                      v-for="(
                        cat, index
                      ) in plansCatalogs.unidadExpiracionRenovacion"
                      :key="index"
                      :label="cat.glosa"
                      :value="cat.glosa"
                    ></el-option>
                  </el-select>
                </div>
                <div class="col-10 py-auto mx-auto text-center p-0 d-md-none">
                  <label for=""
                    >Puntos de Venta<i
                      v-if="foundPlan.sucursalesHabilitadas.length === 0"
                      class="fa fa-exclamation-triangle fa-1x text-danger"
                    ></i
                  ></label>

                  <!-- <button class="btn btn-info">Habilitar Sucursales</button> -->
                  <fg-input>
                    <el-select
                      size="small"
                      multiple
                      :class="{
                        'select-success':
                          foundPlan.sucursalesHabilitadas.length > 0,
                        'select-danger':
                          foundPlan.sucursalesHabilitadas.length === 0,
                      }"
                      v-model="selects.multiple"
                      :placeholder="
                        foundPlan.sucursalesHabilitadas.length > 0
                          ? 'Sucursales'
                          : 'Debes seleccionar al menos uno'
                      "
                      :disabled="disableFoundPlanForm"
                    >
                      <el-option
                        v-for="option in userBranches"
                        class="select-primary"
                        :value="JSON.stringify(option)"
                        :label="option.nombreSucursal"
                        :key="option._id"
                      >
                      </el-option>
                    </el-select>
                  </fg-input>
                </div>
              </div>
              <div
                class="d-none d-md-flex justify-content-start mt-1 px-0 mx-0"
              >
                <div class="col-1 my-auto pl-0 mr-2">
                  <div class="switch d-flex flex-column text-center">
                    <!-- <small
                    ><p class="mb-2 text-nowrap text-muted">
                      Plan Temporal
                    </p></small
                  > -->
                    <label for="" class="text-nowrap">Plan Temporal</label>
                    <p-switch
                      v-model="foundPlan.indicadorVigenciaTemporal"
                      type="success"
                      class="mx-auto"
                      on-text="SI"
                      off-text="NO"
                      :readonly="disableFoundPlanForm"
                    ></p-switch>
                  </div>
                </div>
                <div
                  v-if="foundPlan.indicadorVigenciaTemporal"
                  class="col-3 my-auto d-flex flex-column mr-2"
                >
                  <label for="datePickerfechaAsignacion"
                    >Inicio de Vigencia</label
                  >
                  <el-date-picker
                    id="datePickerfechaAsignacion"
                    type="date"
                    format="dd-MM-yyyy"
                    value-format="dd-MM-yyyy"
                    v-model="foundPlan.fechaInicioVigencia"
                    :readonly="disableFoundPlanForm"
                  >
                  </el-date-picker>
                  <label for="datePickerfechaAsignacion">Fin de Vigencia</label>
                  <el-date-picker
                    id="datePickerfechaAsignacion"
                    type="date"
                    format="dd-MM-yyyy"
                    value-format="dd-MM-yyyy"
                    v-model="foundPlan.fechaTerminoVigencia"
                    :readonly="disableFoundPlanForm"
                  >
                  </el-date-picker>
                </div>

                <div
                  class="my-auto my-0 p-0"
                  :class="{
                    'col-2': foundPlan.indicadorPermiteRenovar,
                    'col-2': !foundPlan.indicadorPermiteRenovar,
                  }"
                >
                  <div class="switch d-flex flex-column text-center">
                    <!-- <small
                    ><p class="mb-2 text-center text-nowrap text-muted">
                      ¿Permite Renovar?
                    </p></small
                  > -->
                    <label for="" class="text-nowrap">¿Permite Renovar?</label>
                    <p-switch
                      v-model="foundPlan.indicadorPermiteRenovar"
                      type="success"
                      class="mx-auto"
                      on-text="SI"
                      off-text="NO"
                      :readonly="disableFoundPlanForm"
                    ></p-switch>
                  </div>
                </div>
                <div
                  v-if="foundPlan.indicadorPermiteRenovar"
                  class="col my-auto d-flex flex-row"
                >
                  <!-- <fg-input
                  v-if="
                    foundPlan.unidadExpiracionRenovacion !== 'INDEFINIDA (I)'
                  "
                  type="number"
                  label="Expiración"
                  v-model="foundPlan.expiracionRenovacion"
                  class="col-5"
                  placeholder=""
                  min="1"
                  :readonly="disableFoundPlanForm"
                >
                </fg-input> -->
                  <div
                    class="my-auto col-2"
                    v-if="
                      foundPlan.unidadExpiracionRenovacion !== 'INDEFINIDA (I)'
                    "
                  >
                    <label for="expiracionRenovacion">Expiración</label>
                    <input
                      type="number"
                      label="Expiración"
                      id="expiracionRenovacion"
                      v-model="foundPlan.expiracionRenovacion"
                      class="form-control"
                      placeholder=""
                      @input="validatePositive"
                      min="1"
                      :readonly="disableFoundPlanForm"
                    />
                  </div>
                  <el-select
                    size="small"
                    v-model="foundPlan.unidadExpiracionRenovacion"
                    placeholder="Selecciona"
                    class="success mt-4 mb-0"
                    :disabled="disableFoundPlanForm"
                  >
                    <el-option
                      el-option
                      v-for="(
                        cat, index
                      ) in plansCatalogs.unidadExpiracionRenovacion"
                      :key="index"
                      :label="cat.glosa"
                      :value="cat.glosa"
                    ></el-option>
                  </el-select>
                </div>
                <div
                  class="col-3 py-auto text-center p-0"
                  :class="{ 'pt-4': foundPlan.indicadorVigenciaTemporal }"
                >
                  <label for=""
                    >Puntos de Venta<i
                      v-if="foundPlan.sucursalesHabilitadas.length === 0"
                      class="fa fa-exclamation-triangle fa-1x text-danger"
                    ></i
                  ></label>

                  <!-- <button class="btn btn-info">Habilitar Sucursales</button> -->
                  <fg-input>
                    <el-select
                      size="small"
                      multiple
                      :class="{
                        'select-success':
                          foundPlan.sucursalesHabilitadas.length > 0,
                        'select-danger':
                          foundPlan.sucursalesHabilitadas.length === 0,
                      }"
                      v-model="selects.multiple"
                      :placeholder="
                        foundPlan.sucursalesHabilitadas.length > 0
                          ? 'Sucursales'
                          : 'Debes seleccionar al menos uno'
                      "
                      :disabled="disableFoundPlanForm"
                    >
                      <el-option
                        v-for="option in userBranches"
                        class="select-primary"
                        :value="JSON.stringify(option)"
                        :label="option.nombreSucursal"
                        :key="option._id"
                      >
                      </el-option>
                    </el-select>
                  </fg-input>
                </div>
              </div>
            </form>
            <div v-if="disableFoundPlanForm" class="d-flex mt-2">
              <p-button
                class="btn-info mx-auto"
                @click="handleFoundPlanEnableEdit()"
                >EDITAR</p-button
              >
            </div>
            <div v-else class="d-flex mt-2">
              <p-button
                class="ml-auto mr-4"
                type="success"
                :disabled="disableFoundPlanForm"
                @click="handleFoundPlanSave()"
                >ACTUALIZAR</p-button
              >
              <p-button
                class="mr-auto"
                type="danger"
                @click="handleFoundPlanEditCanel()"
                >CANCELAR</p-button
              >
            </div>
          </div>
        </card>
      </transition>
      <div class="card">
        <div class="card-header d-flex flex-row justify-content-between">
          <div class="category">Planes - Familias</div>
          <i
            class="fa fa-refresh text-success pointer"
            aria-hidden="true"
            @click="refreshTable()"
          ></i>
        </div>
        <div class="card-body row d-block d-md-flex">
          <div class="d-md-flex flex-row d-none">
            <div class="col-md col-6 d-flex flex-column">
              <label for="subfamilys-dropdown">Familias</label>
              <el-select
                size="small"
                class="select-default"
                v-model="selectedFamily"
                placeholder="Familias"
              >
                <el-option
                  class="select-default"
                  v-for="item in familysCatalog"
                  :key="item._id"
                  :label="item.nombre"
                  :value="JSON.stringify(item)"
                >
                </el-option>
              </el-select>
            </div>
            <div class="col-md col-6 d-flex flex-column">
              <label for="subfamilys-dropdown">Sub-Familias</label>
              <el-select
                size="small"
                id="subfamilys-dropdown"
                class="select-default"
                v-model="selectedSubFamily"
                placeholder="SubFamilias"
              >
                <el-option
                  class="select-default"
                  v-for="item in subFamilysCatalog"
                  :key="item._id"
                  :label="item.nombre"
                  :value="JSON.stringify(item)"
                >
                </el-option>
              </el-select>
            </div>
            <div class="col-md col-6 d-flex flex-column">
              <label for="shitfs-dropdown">Turnos</label>
              <el-select
                size="small"
                class="select-default"
                v-model="selectedShift"
                placeholder="Planes"
                id="shitfs-dropdown"
              >
                <!-- <el-option
                class="select-default"
                :label="'TODOS'"
                :value="JSON.stringify({ _id: 0, nombre: 'TODOS' })"
              >
              </el-option> -->
                <el-option
                  class="select-default"
                  v-for="item in shiftsCatalog"
                  :key="item.id"
                  :label="item.descripcionTurno"
                  :value="JSON.stringify(item)"
                >
                </el-option>
              </el-select>
            </div>
            <div class="col-md col-6 d-flex flex-column">
              <label for="branches-dropdown">Sucursales</label>
              <el-select
                size="small"
                class="select-default"
                v-model="selectedBranch"
                placeholder="Sucursales"
                id="branches-dropdown"
              >
                <el-option
                  class="select-default"
                  v-for="item in userBranches_seach"
                  :key="item._id"
                  :label="item.nombreSucursal"
                  :value="JSON.stringify(item)"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div v-if="this.tableIsLoading" class="container-fluid d-flex">
            <Loading class="mx-auto"></Loading>
          </div>
          <el-tooltip :open-delay="200" placement="top">
            <template #content>
              {{ showMobileFilters ? "Ocultar filtros" : "Filtrar planes" }}
            </template>
            <button
              @click="toggleMobileFilters"
              class="btn d-md-none rounded-circle round-btn p-0 mx-3"
              :class="showMobileFilters ? 'btn-warning' : 'btn-info'"
            >
              <i class="fa fa-filter fa-2x" aria-hidden="true"></i>
            </button>
          </el-tooltip>
          <div
            v-if="showMobileFilters"
            class="d-flex d-md-none flex-row flex-wrap"
          >
            <div class="col-md col-6 d-flex flex-column">
              <label for="subfamilys-dropdown">Familias</label>
              <el-select
                size="small"
                class="select-default"
                v-model="selectedFamily"
                placeholder="Familias"
              >
                <el-option
                  class="select-default"
                  v-for="item in familysCatalog"
                  :key="item._id"
                  :label="item.nombre"
                  :value="JSON.stringify(item)"
                >
                </el-option>
              </el-select>
            </div>
            <div class="col-md col-6 d-flex flex-column">
              <label for="subfamilys-dropdown">Sub-Familias</label>
              <el-select
                size="small"
                id="subfamilys-dropdown"
                class="select-default"
                v-model="selectedSubFamily"
                placeholder="SubFamilias"
              >
                <el-option
                  class="select-default"
                  v-for="item in subFamilysCatalog"
                  :key="item._id"
                  :label="item.nombre"
                  :value="JSON.stringify(item)"
                >
                </el-option>
              </el-select>
            </div>
            <div class="col-md col-6 d-flex flex-column">
              <label for="shitfs-dropdown">Turnos</label>
              <el-select
                size="small"
                class="select-default"
                v-model="selectedShift"
                placeholder="Planes"
                id="shitfs-dropdown"
              >
                <!-- <el-option
                class="select-default"
                :label="'TODOS'"
                :value="JSON.stringify({ _id: 0, nombre: 'TODOS' })"
              >
              </el-option> -->
                <el-option
                  class="select-default"
                  v-for="item in shiftsCatalog"
                  :key="item.id"
                  :label="item.descripcionTurno"
                  :value="JSON.stringify(item)"
                >
                </el-option>
              </el-select>
            </div>
            <div class="col-md col-6 d-flex flex-column">
              <label for="branches-dropdown">Sucursales</label>
              <el-select
                size="small"
                class="select-default"
                v-model="selectedBranch"
                placeholder="Sucursales"
                id="branches-dropdown"
              >
                <el-option
                  class="select-default"
                  v-for="item in userBranches_seach"
                  :key="item._id"
                  :label="item.nombreSucursal"
                  :value="JSON.stringify(item)"
                >
                </el-option>
              </el-select>
            </div>
            <div
              v-if="this.tableIsLoading && isMounted"
              class="container-fluid d-flex"
            >
              <Loading class="mx-auto"></Loading>
            </div>
          </div>
          <div v-if="!this.tableIsLoading && isMounted" class="col-sm-12 mt-2">
            <el-table
              class="table-striped d-none d-md-block"
              :data="plansData"
              style="width: 100%"
            >
              <el-table-column fixed prop="id" label="id" width="50" />
              <el-table-column prop="descripcion" label="nombre" />
              <el-table-column prop="nombreFamilia" label="familia" />
              <el-table-column prop="nombreSubFamilia" label="sub-familia" />
              <el-table-column fixed="right" label="Acciones" width="120">
                <template #default="scope">
                  <div class="w-100 d-flex justify-content-around">
                    <i
                      @click="searchPlan(scope.row)"
                      class="fa button--hover fa-pencil-square-o fa-2x"
                      aria-hidden="true"
                    ></i>
                    <i
                      @click="deletePlan(scope.row)"
                      class="fa button--hover fa-trash fa-2x text-danger"
                      aria-hidden="true"
                    ></i>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <el-table
              class="table-striped d-md-none"
              :data="plansData"
              style="width: 100%"
            >
              <el-table-column fixed prop="id" label="id" width="50" />
              <el-table-column prop="descripcion" label="nombre" />
              <el-table-column fixed="right" label="Acciones" width="120">
                <template #default="scope">
                  <div class="w-100 d-flex justify-content-around">
                    <i
                      @click="searchPlan(scope.row)"
                      class="fa button--hover fa-pencil-square-o fa-2x"
                      aria-hidden="true"
                    ></i>
                    <i
                      @click="deletePlan(scope.row)"
                      class="fa button--hover fa-trash fa-2x text-danger"
                      aria-hidden="true"
                    ></i>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <div class="col-sm-6 container-fluid d-flex mt-4">
            <p-pagination
              class="pull-right mx-auto"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="pagination.total"
            >
              <!-- @input="onPageChange" -->
            </p-pagination>
          </div>
        </div>
      </div>
    </div>
    <shift-update-modal
      ref="shiftUpdateModal"
      v-if="showPlanDetail"
      :shiftData="foundPlan.turno"
      :editShift="disableFoundPlanForm"
    ></shift-update-modal>
  </div>
</template>

<script>
import ShiftUpdateModal from "./Plans/ShiftUpdateModal.vue";
import _ from "lodash";
import { Badge, Modal } from "src/components/UIComponents";
import Card from "src/components/UIComponents/Cards/Card";
import PPagination from "src/components/UIComponents/Pagination.vue";
import Loading from "src/components/Dashboard/Layout/LoadingMainPanel.vue";
import Dropdown from "src/components/UIComponents/Dropdown.vue";
import PSwitch from "src/components/UIComponents/Switch.vue";
import {
  DatePicker,
  TimeSelect,
  Slider,
  Tag,
  Input,
  Button,
  Select,
  Option,
  Table,
  TableColumn,
  Tooltip,
} from "element-ui";
// import { filter } from "vue/types/umd";
export default {
  components: {
    Card,
    Badge,
    Dropdown,
    PPagination,
    Loading,
    PSwitch,
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    [Slider.name]: Slider,
    [Tag.name]: Tag,
    [Input.name]: Input,
    [Button.name]: Button,
    Modal,
    [Option.name]: Option,
    [Select.name]: Select,
    [Tooltip.name]: Tooltip,
    ShiftUpdateModal,
  },
  watch: {
    selectedDiscount: function (newValue) {
      if (this.isLoaded) {
        this.foundPlan.porcentajeDescuento = newValue / 100;
      }
    },
    listSwtich: function (newValue) {
      // console.log("newValue");
      // console.log(newValue);
    },
    "selects.multiple": function (newValue) {
      if (this.isLoaded) {
        // console.log("newValue");
        // console.log(newValue);
        this.foundPlan.sucursalesHabilitadas = newValue.map((branch) =>
          JSON.parse(branch)
        );
      }
    },
    "foundPlan.indicadorMesCalendario": function (newValue, oldValue) {
      if (!newValue && newValue !== oldValue) {
        this.foundPlan.indicadorUsoSesiones = true;
        this.foundPlan.sesionesLimite = this.foundPlan.sesionesLimite || 1;
        this.foundPlan.diasMesNoCalendario = 0;
      } else if (newValue && newValue !== oldValue) {
        this.foundPlan.diasMesNoCalendario = 0;
      }
    },
    "foundPlan.indicadorUsoSesiones": function (newValue, oldValue) {
      if (newValue && !oldValue) {
        this.foundPlan.sesionesLimite = this.foundPlan.sesionesLimite || 1;
      } else if (!newValue && oldValue) {
        this.foundPlan.sesionesLimite = 0;
      }
    },
    updatedFamily: function (newFamily) {
      // console.log("newFamily");
      // console.log(newFamily);
      if (this.isLoaded) {
        // this.updatedFamily = newFamily.nombre;
        this.foundPlan.idFamilia = newFamily.id;
        this.foundPlan.nombreFamilia = newFamily.nombre;
      }
    },
    updatedSubFamily: function (newSubFamily) {
      if (this.isLoaded) {
        this.foundPlan.idSubFamilia = newSubFamily.id;
        this.foundPlan.nombreSubFamilia = newSubFamily.nombre;
      }
    },
    "foundPlan.indicadorVigenciaTemporal": function (newValue) {
      if (this.isLoaded) {
        if (!newValue) {
          this.foundPlan.fechaInicioVigencia = "";
          this.foundPlan.fechaTerminoVigencia = "";
        } else {
          this.foundPlan.fechaInicioVigencia = this.$moment()
            .startOf("month")
            .format("DD-MM-YYYY");
          this.foundPlan.fechaTerminoVigencia = this.$moment()
            .endOf("month")
            .format("DD-MM-YYYY");
        }
      }
    },
    "foundPlan.unidadExpiracionRenovacion": function (newValue, oldValue) {
      // console.log("newValue: ", newValue, "oldValue: ", oldValue);
      if (newValue === "INDEFINIDA (I)") {
        this.foundPlan.expiracionRenovacion = 0;
      } else if (oldValue === "INDEFINIDA (I)") {
        this.foundPlan.expiracionRenovacion = 1;
      }
    },
    "pagination.currentPage": function (newValue, oldValue) {
      this.getPlans(newValue - 1);
    },
    "foundMembership.expiracionRenovacion": function (newValue) {
      if (newValue !== null && newValue !== "") {
        this.foundMembership.expiracionRenovacion = parseInt(newValue, 10);
      }
    },
    "foundMembership.valorPlan": function (newValue) {
      if (newValue !== null && newValue !== "") {
        this.foundMembership.valorPlan = parseInt(newValue, 10);
      }
    },
    "foundMembership.sesionesUtilizadas": function (newValue) {
      if (newValue !== null && newValue !== "") {
        this.foundMembership.sesionesUtilizadas = parseInt(newValue, 10);
      }
    },
    "foundMembership.sesionesLimite": function (newValue) {
      if (newValue !== null && newValue !== "") {
        this.foundMembership.sesionesLimite = parseInt(newValue, 10);
      }
    },
    "foundMembership.valorMatricula": function (newValue) {
      if (newValue !== null && newValue !== "") {
        this.foundMembership.valorMatricula = parseInt(newValue, 10);
      }
    },
    selectedPlan: function (newValue) {
      if (newValue) {
        let planData = newValue === "TODAS" ? newValue : JSON.parse(newValue);
        // console.log(planData);
        this.filters.plan = planData._id;
        this.filters.family = planData.familia;
        this.filters.subFamily = planData.idSubFamilia;
        Promise.all([
          this.getFamilysCatalog(),
          this.getSubFamilysCatalog(),
          this.getPlansCatalog(),
          this.getPlans(0),
        ]).then(() => {});
      }
    },
    selectedSubFamily: function (newValue) {
      if (newValue) {
        let subFamily = newValue === "TODAS" ? newValue : JSON.parse(newValue);
        // console.log(subFamily);
        if (this.filters.update) {
          this.filters.idFamilia =
            typeof subFamily.idFamilia === "number"
              ? subFamily.idFamilia
              : false;
          this.filters.idSubFamilia = subFamily.id;
          this.filters.plan = false;
          Promise.all([
            this.updateFilters(),
            this.getPlansCatalog(),
            this.getPlans(0),
          ]).then(() => {});
        } else {
          // console.log("nope");
          // console.log(subFamily);
        }
      }
    },
    selectedFamily: function (newValue) {
      if (newValue) {
        let family = newValue === "TODAS" ? newValue : JSON.parse(newValue);

        if (this.filters.update) {
          this.filters.idFamilia = family.id;
          this.filters.idSubFamilia = false;
          Promise.all([this.updateFilters(), this.getPlans(0)]).then(() => {});
        }
      }
    },
    selectedShift: async function (newValue) {
      if (newValue && this.filters.update) {
        let shift = newValue === "TODOS" ? newValue : JSON.parse(newValue);
        if (this.filters.update) {
          this.filters.turno = shift.id;
          await this.getPlans(0)
            .then(() => {
              return;
            })
            .catch((ex) => {
              // console.log("catch++++++++++");
              console.error(ex.message);
              console.error(ex);
            });
          // console.log("sip");
          // console.log(shift);
        } else {
          // console.log("nopes");
          // console.log(shift);
        }
      }
    },
    selectedBranch: async function (newValue) {
      // console.log("selectedBranch: ", newValue);
      if (newValue) {
        // console.log("prefail");
        // console.log(newValue);
        const currentSelectedBranch =
          typeof newValue === "object" ? newValue : JSON.parse(newValue);
        // console.log(currentSelectedBranch._id);
        if (this.filters.update) {
          this.filters.sucursal = currentSelectedBranch._id;
          await this.getPlans()
            .then(() => {})
            .catch((ex) => {
              console.error("Error");
              console.error(ex);
            });
        }
      }
    },
  },
  data() {
    return {
      selectedDiscount: 0,
      showMobileFilters: false,
      discounts: [
        0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85,
        90, 95, 100,
      ],
      listSwtich: false,
      selects: { multiple: [] },
      updatedSubFamily: {},
      updatedFamily: {},
      isLoaded: false,
      isMounted: false,
      showPlanDetail: false,
      disableFoundPlanForm: true,
      pagination: {
        perPage: 10,
        currentPage: 1,
        catalog: [{ glosa: "TODOS", _id: false }],
        total: this.$store.getters.getMembershipCounter,
        currentFilter: "TODOS",
      },
      plansData: [],
      currentFilter: false,
      tableColumns: [
        {
          prop: "id",
          label: "id",
          width: 10,
        },
        {
          prop: "descripcion",
          label: "Nombre",
          minWidth: 200,
        },
      ],
      tableIsLoading: false,
      cardIsLoading: false,
      searchQuery: "",
      foundMember: {
        id: "",
        name: "",
        branch: "",
        registrationDate: "",
        type: "",
        phoneMobile: "",
        phone: "",
        nationalId: "",
        company: "",
        username: "",
        email: "",
        firstName: "",
        lastName: "",
        address: "",
        city: "",
        state: "",
        country: "",
        postalCode: "",
        aboutMe: "",
        currentStatus: "VIGENTE",
        avatar: "",
        currentAccountType: "",
      },
      activeMembershipID: "",
      membershipReadOnly: true,
      showDetails: false,
      activeCatlog: [],
      foundMemberAccesResum: {},
      mobileDetailToggle: null,
      familysCatalog: [{ _id: false, nombre: "TODAS" }],
      subFamilysCatalog: [{ _id: false, nombre: "TODAS", idFamilia: false }],
      shiftsCatalog: [{ id: false, descripcionTurno: "TODOS" }],
      plansCatalog: [
        { _id: false, nombre: "TODAS", familia: false, idSubFamilia: false },
      ],
      filters: {
        idFamilia: false,
        idSubFamilia: false,
        turno: false,
        sucursal: false,
        update: true,
      },
      selectedFamily: false,
      selectedSubFamily: false,
      selectedPlan: false,
      selectedShift: { id: false, descripcionTurno: "TODOS" },
      selectedBranch: false,
      updatedPlan: false,
      updatedShift: { id: false, descripcionTurno: "TODOS" },
      updateFamilysCatalog: [],
      updateSubFamilysCatalog: [],
      updateShiftsCatalog: [],
      updateFamilysCatalogOG: [],
      updateSubFamilysCatalogOG: [],
      updateShiftsCatalogOG: [],
      userBranches: [],
      userBranches_seach: [],
      updatedBranch: [],
      foundPlan: {},
      foundPlanOG: {},
      plansCatalogs: {},
    };
  },
  methods: {
    validatePositive(event) {
      const value = parseFloat(event.target.value);
      // console.log(event.target);
      const key = event.target.id;
      if (value < 0 || isNaN(value)) {
        this.foundPlan[key] = 0;
      } else {
        this.foundPlan[key] = this.foundPlan[key];
      }
    },
    showShiftModal() {
      this.$refs.shiftUpdateModal.showModal();
    },
    test() {
      console.log(this.foundPlanOG);
      // this.$swal
      //   .fire({
      //     title: "Error! :(",
      //     text: "Ha ocurrido un error al refrescar, actualizará la ventana",
      //     icon: "error",
      //     showConfirmButton: true,
      //   })
      //   .then(() => {
      //     window.location.reload();
      //   });
    },
    async refreshTable() {
      this.$swal.fire({
        text: "Un segundo por favor...",
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      this.filters.idFamilia = false;
      this.filters.idSubFamilia = false;
      this.filters.plan = false;
      this.filters.turno = false;
      this.filters.sucursal = false;

      try {
        await this.updateFilters();
        await this.getPlansCatalog();
        await this.getPlans(0);
        this.$swal.close();
      } catch (ex) {
        console.error(ex.message || ex);
        this.$swal
          .fire({
            title: "Error! :(",
            text: "Ha ocurrido un error al refrescar, se actualizará la ventana",
            icon: "error",
            showConfirmButton: true,
          })
          .then(() => {
            window.location.reload();
          });
      }
    },
    async calculateSubFamilys(el) {
      // console.log("recalculando con id: ", el);
      const famId = el._id;

      this.updateSubFamilysCatalog = this.updateSubFamilysCatalogOG.filter(
        (subFam) => subFam.familia === famId
      );
      // if (this.isLoaded){
      //   this.foundPlan.idFamilia = el.id
      //   this.foundPlanOG.nombreFamilia = el.nombre
      // }
    },
    toggleMobileFilters() {
      this.showMobileFilters = !this.showMobileFilters;
    },
    async testFunction() {
      // console.log(this.foundPlan)
      // console.log("this.updateFamilysCatalog");
      // console.log(this.updateFamilysCatalog);
      // console.log("this.updateSubFamilysCatalog");
      // console.log(this.updateSubFamilysCatalog);
      // console.log("this.updateShiftsCatalog");
      // console.log(this.updateShiftsCatalog);
    },
    handleBranchChange(selectedValue) {
      // if (selectedValue[0].nombreSucursal === "multiSede") {
      //   this.updatedBranch = "Multi-Sede";
      //   this.foundPlan.sucursalesHabilitadas = this.userBranches;
      //   this.foundPlan.multiSede = true;
      // } else {
      //   this.updatedBranch = selectedValue[0].nombreSucursal;
      //   this.foundPlan.multiSede = false;
      //   this.foundPlan.sucursalesHabilitadas = selectedValue;
      // }
    },
    async getPlansCatalogs() {
      let response;
      try {
        response = await this.$MasterControlAPP.post(
          "",
          {
            Parameters: {},
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: sessionStorage.getItem("jCxbraoQeD"),
              operation: "/v1/get/plans/catalogs",
              // operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q")).MembershipsStatistics,
            },
          }
        );
        if (response.data) {
          // console.log(response.data);
          this.plansCatalogs = response.data;
          // console.log(this.plansCatalogs);
        }
      } catch (error) {
        console.error("Error");
        console.error(error);
      }
    },
    async handleFoundPlanEnableEdit() {
      this.disableFoundPlanForm = false;
      this.foundPlanOG = _.cloneDeep(this.foundPlan);
    },
    async handleFoundPlanSave() {
      let updatedFields = {};
      try {
        Object.keys(this.foundPlan).forEach((key) => {
          if (!_.isEqual(this.foundPlan[key], this.foundPlanOG[key])) {
            // console.log("this.foundPlan[key] -> " + this.foundPlan[key]);
            // console.log("this.foundPlanOG[key] -> " + this.foundPlanOG[key]);
            updatedFields[key] = this.foundPlan[key];
          }
        });
      } catch (error) {
        console.error(error);
      }
      if (Object.keys(updatedFields).length > 0) {
        const updateShift = Object.keys(updatedFields).filter(
          (i) => i === "turno"
        );
        // console.log(updateShift);
        new this.$swal({
          title: "¿Estás seguro?",
          text: `Has modificado: ${Object.keys(updatedFields).join(",")}`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#6bd098",
          cancelButtonColor: "#eb6532",
          confirmButtonText: "Sí, guardar cambios",
          cancelButtonText: "Cancelar",
        }).then(async (result) => {
          if (result.isConfirmed) {
            await this.updatePlan(updateShift.length > 0); // Método que guarda los cambios
            // console.log(this.foundPlan);
          } else {
            this.cancelPlanEdit();
          }
        });
      } else {
        new this.$swal({
          title: "No hay Cambios",
          text: "No tienes cambios que guardar",
          icon: "info",
          confirmButtonText: "entendido",
          customClass: {
            confirmButton: "btn btn-success",
          },
        }).then((result) => {
          this.handleFoundPlanEditCanel(); // Método que guarda los cambios
          // if (result.isConfirmed) {
          // }
        });
      }
    },
    async updatePlan(updateShift) {
      this.$swal.fire({
        title: "Actualizando...",
        text: "Por favor espera",
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: () => {
          this.$swal.showLoading();
        },
      });
      var errorArray = [];
      var { __v, _id, createdAt, updatedAt, ...updatedPlan } = this.foundPlan;

      updatedPlan.valor = !updatedPlan.valor
        ? 0
        : parseFloat(updatedPlan.valor);
      updatedPlan.sesionesLimite = !updatedPlan.sesionesLimite
        ? 0
        : parseInt(updatedPlan.sesionesLimite);
      updatedPlan.valorMatricula = !updatedPlan.valorMatricula
        ? 0
        : parseFloat(updatedPlan.valorMatricula);
      updatedPlan.duracion = !updatedPlan.duracion
        ? 0
        : parseInt(updatedPlan.duracion);
      updatedPlan.diasPermitidoCongelar = !updatedPlan.diasPermitidoCongelar
        ? 0
        : parseInt(updatedPlan.diasPermitidoCongelar);
      updatedPlan.diasMesNoCalendario = !updatedPlan.diasMesNoCalendario
        ? 0
        : parseInt(updatedPlan.diasMesNoCalendario);
      updatedPlan.expiracionRenovacion = !updatedPlan.expiracionRenovacion
        ? 0
        : parseInt(updatedPlan.expiracionRenovacion);
      // console.log(updatedPlan.turno.idTurno);
      updatedPlan.turno.idTurno = !updatedPlan.turno.idTurno
        ? 0
        : parseInt(updatedPlan.turno.idTurno);

      if (updatedPlan.sucursalesHabilitadas.length === 0) {
        errorArray.push("Debes seleccionar sucursal para tu plan");
      }
      if (!updatedPlan.descripcion) {
        errorArray.push("Debes ingresar un nombre valido para tu plan");
      }
      if (isNaN(`${updatedPlan.valor}`)) {
        errorArray.push(
          "Debes ingresar un numero valido como valor de tu plan"
        );
      }
      if (isNaN(`${updatedPlan.valorMatricula}`)) {
        errorArray.push(
          "Debes ingresar un numero valido como valor para la matricula de tu plan"
        );
      }
      if (typeof updatedPlan.habilitarVenta === "undefined") {
        updatedPlan.habilitarVenta === true;
      }
      if (isNaN(`${updatedPlan.turno.idTurno}`)) {
        errorArray.push(`El Id de turno no es valido, por favor refresca la ventana`)
      }
      Object.keys(updatedPlan.turno).forEach((key) => {
        switch (true) {
          case /Hora/.test(key):
            // Realizar validación con expresión regular
            let valor = updatedPlan.turno[key]
              ? updatedPlan.turno[key]
              : "00:00:00";
            const formatoIncompleto = /^(?:[01]\d|2[0-3]):[0-5]\d$/.test(valor);

            valor = formatoIncompleto ? valor + ":00" : valor;
            updatedPlan.turno[key] = valor;
            break;
          default:
            break;
        }
      });
      if (errorArray.length === 0) {
        try {
          const result = await this.$MasterControlAPI.post(
            "",
            {
              Header: {
                Operacion: "/user/actualizar/plan",
              },
              Auth: {
                Token: sessionStorage.getItem("jCxbraoQeD"),
              },
              Parameters: {
                idSucursal: sessionStorage.getItem("nu5za9cv6q"),
                nombreSucursal: sessionStorage.getItem("qtsb4ec3d8"),
                id: updatedPlan.id,
                updateShift: updateShift,
              },
              Body: updatedPlan,
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          this.$swal.close();
          if (
            result.data.Response.Resultado.CodigoHTTP === 201 ||
            result.data.Response.Resultado.CodigoHTTP === 200
          ) {
            this.foundPlan;
            this.disableFoundPlanForm = true;
            new this.$swal({
              title: "OK!",
              text: "Haz modificado el plan de forma exitosa",
              icon: "success",
              confirmButtonColor: "#6bd098",
              confirmButtonText: "ok",
            }).then((result) => {
              this.backToSearch();
              // if (result.isConfirmed) {
              //   this.updateMembership(updatedFields); // Método que guarda los cambios
              // } else {
              //   this.cancelMembershipEdit();
              // }
            });
          } else {
            this.foundPlanOG = this.foundPlan;
            this.disableFoundPlanForm = true;
            new this.$swal({
              title: "ERROR!",
              text: result.data.Response.Resultado.MensajeInterno,
              icon: "warning",
              confirmButtonColor: "#eb6532",
              confirmButtonText: "ok",
            });
          }
        } catch (error) {
          this.$swal.close();
          this.foundPlanOG = this.foundPlan;
          this.disableFoundPlanForm = true;
          new this.$swal({
            title: "ERROR!",
            text: error.response.data.Response.Resultado.MensajeServicio,
            icon: "error",
            confirmButtonColor: "#eb6532",
            confirmButtonText: "ok",
          });
          console.log(error.response.data.Response.Resultado);
          console.error("Error: ", error.message);
        }
      } else {
        this.$swal.close();
        const errorString =
          errorArray.length > 1 ? errorArray.join(", ") : errorArray[0];

        this.$swal.fire({
          title: "Hay un problema con tu plan!",
          text: errorString,
          icon: "error",
          showConfirmButton: true,
        });
      }
    },
    handleFoundPlanEditCanel() {
      this.disableFoundPlanForm = true;
      // this.disableFoundPlanForm = false;
      // console.log(this.foundPlanOG);
      this.foundPlan = _.cloneDeep(this.foundPlanOG);
      this.selects.multiple = this.foundPlanOG.sucursalesHabilitadas.map(
        (branch) => JSON.stringify(branch)
      );
      this.foundPlanOG = {};
    },
    async getCatalog() {
      try {
        const catalog = await this.$MasterControlAPP.post(
          "",
          {
            dataSource: "DataAPI",
            database: this.$ToDesa ? "mb3-gym-desa" : "mb3-gym-prod",
            collection: "plan_catalogo_estados_pago",
            pipeline: [
              {
                $match: {
                  glosa: { $ne: "R:PENDIENTE" },
                },
              },
              {
                $project: {
                  _id: 1,
                  glosa: 1,
                },
              },
            ],
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: sessionStorage.getItem("jCxbraoQeD"),
              operation: "/data/v1/action/aggregate",
              // operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q"))
              //   .AccessStatistics,
            },
          }
        );
        // console.log(catalog.data.documents);
        let catActivos = { glosa: "ACTIVOS", _id: [] };
        catalog.data.documents.forEach((catalog) => {
          catalog._id = [{ $oid: catalog._id }];
          switch (catalog.glosa) {
            case "VIGENTE":
              catActivos._id.push(catalog._id[0]);
              break;
            case "PENDIENTE":
              break;
            case "PAGADO":
              catActivos._id.push(catalog._id[0]);
              break;
            case "CONGELADO":
              catActivos._id.push(catalog._id[0]);
              break;
          }
        });
        this.pagination.catalog = [
          ...this.pagination.catalog,
          catActivos,
          ...catalog.data.documents,
        ];
        // console.log("this.pagination.catalog*************");
        // console.log(catalog);
      } catch (ex) {
        console.error("Error: [getCatalog] - ", ex);
      }
    },
    async getPlans(page) {
      // console.log("calling");
      this.showDetails = false;
      let matchStage = {};
      this.plansData = [];
      this.tableIsLoading = true;
      this.activeMembershipID = "";
      var filter = {};

      if (typeof this.filters.idFamilia === "number") {
        filter.idFamilia = this.filters.idFamilia;
      }
      if (typeof this.filters.idSubFamilia === "number") {
        filter.idSubFamilia = this.filters.idSubFamilia;
      }
      if (typeof this.filters.turno === "number") {
        filter.turno = this.filters.turno;
      }
      // console.log("this.filters.sucursal************************");
      // console.log(this.filters.sucursal);
      if (this.filters.sucursal) {
        filter.sucursal = this.filters.sucursal;
      }
      // console.log("matchStage");
      // console.log(matchStage);
      try {
        const resp = await this.$MasterControlAPP.post(
          "",
          {
            Parameters: {
              filter: { ...filter },
              page: page ? page : 0,
            },
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: sessionStorage.getItem("jCxbraoQeD"),
              operation: "/v1/get/plans",
              // operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q"))
              //   .AccessStatistics,
            },
          }
        );
        // console.log("*************resp***************")
        // console.log(resp)

        this.pagination.total = resp.data.count;
        // console.log("this.pagination.total")
        // console.log(this.pagination.total)
        this.plansData = resp.data.result;
        // console.log(resp.data);
      } catch (ex) {
        console.error("***************PLANS");
        console.error(ex);
      } finally {
        this.tableIsLoading = false;
      }
    },
    async searchPlan(row) {
      this.disableFoundPlanForm = true;
      this.foundPlan = {};
      this.showPlanDetail = false;
      this.isLoaded = false;
      const planId = row.id;
      this.$swal.fire({
        title: "Cargando",
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: () => {
          this.$swal.showLoading();
        },
      });
      // console.log("planId: " + planId);
      var isConfirmed;
      // console.log("Consultando plan...");
      try {
        await this.$MasterControlAPI
          .post(
            "",
            {
              Header: {
                Operacion: "/user/consultar/plan",
              },
              Auth: {
                Token: sessionStorage.getItem("jCxbraoQeD"),
              },
              Parameters: {
                id: planId,
              },
              Body: {},
            },
            {
              headers: {
                "Content-Type": "application/json",
                token: sessionStorage.getItem("jCxbraoQeD"),
                operation: "/user/consultar/plan",
                // operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q"))
                //   .AccessStatistics,
              },
            }
          )
          .then((resp) => {
            if (resp.data.error) {
              this.$swal.close();
              this.$swal.fire({
                title: "Ha ocurrido un error :(!",
                icon: "error",
                text: resp.data.error,
                showConfirmButton: true,
              });
            } else {
              // console.log(resp);
              var {
                unidadDuracionPlan,
                unidadExpiracionRenovacion,
                convenio,
                ...foundPlan
              } = resp.data.Response.DataOut;
              // console.log(resp.data.Response.DataOut);
              // console.log(foundPlan.id);
              foundPlan.unidadDuracionPlan = unidadDuracionPlan.glosa;
              foundPlan.unidadExpiracionRenovacion =
                unidadExpiracionRenovacion.glosa;
              foundPlan.convenio = convenio.glosa;
              if (typeof foundPlan.habilitarVenta === "undefined") {
                foundPlan.habilitarVenta === true;
              }
              this.selectedDiscount = foundPlan.porcentajeDescuento * 100;
              // console.log(foundPlan);
              this.foundPlan = { ...foundPlan };
              this.foundPlanOG = { ...this.foundPlan };
              if (foundPlan.multiSede) {
                this.updatedBranch = "Multi-Sede";
              } else {
                this.updatedBranch = foundPlan.sucursalesHabilitadas[0];
              }

              this.updatedFamily = foundPlan.nombreFamilia;
              this.updatedSubFamily = foundPlan.nombreSubFamilia;
              // console.log("this.selects.multiple")
              // console.log(this.selects.multiple)
              // console.log("foundPlan.sucursalesHabilitadas")
              // console.log(foundPlan.sucursalesHabilitadas)
              this.selects.multiple = foundPlan.sucursalesHabilitadas.map(
                (branch) => JSON.stringify(branch)
              );
              this.$swal.close();
              this.showPlanDetail = true;
            }
          })
          .catch((ex) => {
            // console.error("Error oyeee")
            this.$swal.close();
            this.$swal.fire({
              title: "ERROR!",
              text: ex.message || "",
              icon: "error",
            });
            console.error(ex);
          });

        await this.calculateSubFamilys({ id: this.foundPlan.idFamilia });
      } catch (ex) {
        this.$swal.close();
        this.$swal.fire({
          title: "ERROR!",
          text: ex.message || "",
          icon: "error",
        });
        // console.log(ex);
      } finally {
        // console.log("inicio scroll");
        window.scrollTo({ top: 100, behavior: "smooth" });
        // console.log("fin scroll");
        this.isLoaded = true;
        return;
      }
    },
    async updateFilters() {
      this.filters.update = false;
      const filters = this.filters;
      // console.log("filters*************");
      // console.log(filters);
      try {
        await this.$MasterControlAPP
          .post(
            "",
            {
              Parameters: {
                filter: { ...filters },
              },
            },
            {
              headers: {
                "Content-Type": "application/json",
                token: sessionStorage.getItem("jCxbraoQeD"),
                operation: "/v1/update/filters/planscatalog",
                // operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q"))
                //   .AccessStatistics,
              },
            }
          )
          .then((resp) => {
            // console.log(resp.data);
            let fams = resp.data.famCatalog;
            let subFams = resp.data.subFamCatalog;
            if (this.isMounted) {
              // console.log("creando catalog para actualizacion");
              this.updateFamilysCatalog = [...fams];
              this.updateFamilysCatalogOG = [...fams];
            }
            this.familysCatalog = [{ _id: false, nombre: "TODAS" }, ...fams];
            this.subFamilysCatalog = [
              { _id: false, nombre: "TODAS", idFamilia: false },
              ...subFams,
            ];
            this.selectedFamily = this.selectedFamily
              ? this.selectedFamily
              : this.familysCatalog[0].nombre;
            this.selectedSubFamily = this.selectedSubFamily
              ? this.selectedSubFamily
              : this.subFamilysCatalog[0].nombre;
          });
      } catch (ex) {
        console.error("Error: [updateFilters]");
        console.error(ex.message ? ex.message : ex);
      } finally {
        this.filters.update = true;
        return;
      }
    },
    async deletePlan(row) {
      const planId = row._id;
      const planNumericId = row.id;
      this.showDetails = false;
      // console.log("planId: " + planId);
      let updatedPlanslist = [];
      var isConfirmed;
      await this.$swal
        .fire({
          text: "Esto no puede revertirse!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Si, eliminalo!",
          cancelButtonText: "Cancelar",
        })
        .then((res) => {
          // console.log(res);
          isConfirmed = res.isConfirmed;
        });

      if (isConfirmed) {
        // console.log("Eliminando plan...");
        this.$swal.fire({
          title: "Cargando",
          allowOutsideClick: false,
          showConfirmButton: false,
          willOpen: () => {
            this.$swal.showLoading();
          },
        });
        try {
          await this.$MasterControlAPP
            .post(
              "",
              {
                Parameters: {
                  id: planId,
                },
              },
              {
                headers: {
                  "Content-Type": "application/json",
                  token: sessionStorage.getItem("jCxbraoQeD"),
                  operation: "/v1/delete/plan",
                  // operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q"))
                  //   .AccessStatistics,
                },
              }
            )
            .then((resp) => {
              // console.log("resp++++++++++++++++++++");
              // console.log(resp);
              this.$swal.close();
              if (resp.data.error) {
                this.$swal.fire({
                  title: "Ha ocurrido un error :(!",
                  icon: "error",
                  text: resp.data.error,
                  showConfirmButton: true,
                });
              } else {
                if (this.plansData.length > 1) {
                  updatedPlanslist = _.filter(
                    this.plansData,
                    (plan) => plan.id !== planNumericId
                  );
                } else {
                  this.getPlans(0);
                }
                this.plansData = updatedPlanslist;
                this.$swal.fire({
                  title: "Exito",
                  icon: "success",
                  showConfirmButton: true,
                });
              }
            });
        } catch (ex) {
        } finally {
          this.filters.update = true;
          return;
        }
      } else {
        console.warn("Eliminacion canselada por usuario");
      }
    },
    async getShiftsCatalog() {
      this.filters.update = false;
      try {
        await this.$MasterControlAPP
          .post(
            "",
            {
              Parameters: {},
            },
            {
              headers: {
                "Content-Type": "application/json",
                token: sessionStorage.getItem("jCxbraoQeD"),
                operation: "/v1/get/shift/resum",
                // operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q"))
                //   .AccessStatistics,
              },
            }
          )
          .then((resp) => {
            let shiftsCatalog = resp.data.result;
            // console.log("creando catalogo de turnos: ", this.isMounted);
            this.shiftsCatalog = [
              { id: false, descripcionTurno: "TODOS" },
              ...shiftsCatalog,
            ];
            this.selectedShift = JSON.stringify(this.shiftsCatalog[0]);
          });
      } catch (ex) {
        console.error("Error: [getShiftsCatalog]");
        console.error(ex.message ? ex.message : ex);
      } finally {
        this.filters.update = true;
        return;
      }
    },
    onPageChange(newPage) {
      // console.log('cambiando pagina')
      this.getPlans(newPage - 1);
      // this.pagination.currentPage = newPage;
      // this.getLastCashClosing(); // Llama a la función que carga los datos para la nueva página
    },
    enablePlanEdit() {
      this.foundPlanOG = { ...this.foundPlan };
      this.planReadOnly = false;
    },
    cancelPlanEdit() {
      this.foundPlan = { ...this.foundPlanOG };
      this.planReadOnly = true;
      this.foundPlanOG = {};
      this.foundMemberAccesResum = {};
    },
    async backToSearch() {
      this.showPlanDetail = false;
      this.getPlans(0);
    },
    async getFamilysCatalog() {
      // console.log("getFamilysCatalog");
      // console.log(this.isMounted);
      this.familysCatalog = [];
      try {
        const resp = await this.$MasterControlAPP.post(
          "",
          {
            Parameters: {},
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: sessionStorage.getItem("jCxbraoQeD"),
              // operation: "/v1/get/familyscatalog",
              operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q"))
                .GetFamilysCatalog,
            },
          }
        );
        // console.log(resp);
        if (resp.data.length > 0) {
          if (!this.isMounted) {
            // this.updateFamilysCatalog = [...resp.data];
            // this.updateFamilysCatalogOG = [...resp.data];
            // console.log("this.updateFamilysCatalog");
            // console.log(this.updateFamilysCatalog);
          }
          this.familysCatalog = [{ _id: false, nombre: "TODAS" }, ...resp.data];
          return resp.data;
        } else {
          console.error("Error en la llamada, respuesta vacía");
        }
      } catch (error) {
        console.error("ERROR: ", error.message);
      }
    },
    async getSubFamilysCatalog() {
      this.subFamilysCatalog = [];
      try {
        const resp = await this.$MasterControlAPP.post(
          "",
          {
            Parameters: {
              idFamilia: this.filters.family,
            },
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: sessionStorage.getItem("jCxbraoQeD"),
              // operation: "/v1/get/subfamilyscatalog",
              operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q"))
                .GetSubFamilysCatalog,
            },
          }
        );
        // console.log(resp);
        if (resp.data.length > 0) {
          this.subFamilysCatalog = [
            { _id: false, nombre: "TODAS", idFamilia: false },
            ...resp.data,
          ];
          return resp.data;
        } else {
          console.error("Error en la llamada, respuesta vacía");
        }
      } catch (error) {
        console.error("ERROR: ", error.message);
      }
    },
    async getSubFamilysCatalog_PlanUpdate() {
      // console.log(`ejecutando getSubFamilysCatalog_PlanUpdate...`);
      this.updateSubFamilysCatalog = [];
      try {
        // console.log("waka waka eh eh");
        const resp = await this.$MasterControlAPP.post(
          "",
          {
            Parameters: {
              filter: { idFamilia: false },
            },
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: sessionStorage.getItem("jCxbraoQeD"),
              // operation: "/v1/get/subfamilyscatalog",
              operation: "/v1/update/filters/planscatalog",
            },
          }
        );
        // console.log("resp+++++++++++++++++++++++++++++++++++++++++++++++++++");
        // console.log(resp.data.subFamCatalog);
        if (resp.data.subFamCatalog.length > 0) {
          this.updateSubFamilysCatalog = [...resp.data.subFamCatalog];
          this.updateFamilysCatalog = [...resp.data.famCatalog];
          // console.log("sub familias update");
          // console.log(this.updateSubFamilysCatalog);
          return resp.data;
        } else {
          console.error("Error en la llamada, respuesta vacía");
        }
      } catch (error) {
        console.error("ERROR: ", error.message);
        console.error(error);
      } finally {
        this.updateSubFamilysCatalogOG = [...this.updateSubFamilysCatalog];
      }
    },
    async getPlansCatalog() {
      // console.log("ññaaa");
      // this.subFamilysCatalog = [];
      try {
        const resp = await this.$MasterControlAPP.post(
          "",
          {
            Parameters: {
              idFamilia: this.filters.family ? this.filters.family : 0,
              idSubFamilia: this.filters.subFamily ? this.filters.subFamily : 0,
            },
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: sessionStorage.getItem("jCxbraoQeD"),
              // operation: "/v1/get/planscatalog",
              operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q"))
                .GetPlansCatalog,
            },
          }
        );
        // console.log(resp);
        if (resp.data.length > 0) {
          this.plansCatalog = [
            {
              _id: false,
              nombre: "TODAS",
              familia: false,
              idSubFamilia: false,
            },
            ...resp.data,
          ];
          return resp.data;
        } else {
          console.error("Error en la llamada, respuesta vacía");
        }
      } catch (error) {
        console.error("ERROR: ", error.message);
      }
    },
  },
  beforeMount() {
    this.$sidebar.toggleMinimize();
    this.userBranches = [...JSON.parse(sessionStorage.getItem("xxxwypt5ip"))];
    this.userBranches_seach = [
      { _id: false, nombreSucursal: "TODAS" },
      ...JSON.parse(sessionStorage.getItem("xxxwypt5ip")),
    ];
    // this.currentFilter = this.$store.getters.getMembershipFilter;
    // if (this.$store.getters.getMembershipsDDtag) {
    //   this.pagination.currentFilter = this.$store.getters.getMembershipsDDtag;
    // }
    // console.log("this.currentFilter");
    // console.log(this.currentFilter);
  },
  mounted() {
    if (this.$sidebar.isMinimized) {
      this.$sidebar.toggleMinimize();
    }
    this.tableIsLoading = true;
    this.filters.update = false;
    this.$nextTick(() => {
      this.selectedBranch = this.userBranches[0];
      // console.log("this.selectedBranch********");
      // console.log(this.selectedBranch);
      Promise.all([
        // this.getPlans(0),
        this.updateFilters(),
        this.getPlansCatalogs(),
        this.getPlansCatalogs(),
        this.getShiftsCatalog(),
        this.getSubFamilysCatalog_PlanUpdate(),
      ]).then(() => {
        // console.log(this.shiftsCatalog);
        this.updateShiftsCatalog = this.shiftsCatalog.slice(1);
        this.updateShiftsCatalogOG = this.shiftsCatalog.slice(1);
        this.$swal.close();
        this.filters.update = true;
        this.isMounted = true;
      });
    });
  },
  beforeDestroy() {
    this.$swal.fire({
      title: "Cargando...",
      allowOutsideClick: false,
      showConfirmButton: false,
      willOpen: () => {
        this.$swal.showLoading();
      },
    });
  },
  destroyed() {
    this.$store.commit("setMembershipFilter", "");
    this.$store.commit("setMembershipsDDtag", "");
  },
};
</script>

<style>
.button--hover {
  text-shadow: 3px 3px 3px #00000017;
}
.button--hover:hover {
  font-size: 40px;
  text-shadow: 4px 4px 4px #00000042;
}
.round-btn {
  height: 50px;
  width: 50px;
}
.pointer {
  cursor: pointer;
}
</style>
